<div class="content-wrapper">

  <div class="title-container">
    <div class="track-container">
      @if (showView) {
        <div class="track-title-container">
          <tun-scrollable-text class="trackTitle" [text]="trackInfoOverlayData.track.title"></tun-scrollable-text>
        </div>
      }
      @if (showView) {
        <div class="track-group-container">
          <tun-scrollable-text class="trackGroup" [text]="trackInfoOverlayData.track.group"></tun-scrollable-text>
        </div>
      }
    </div>

    <button class="icon-button" (click)="onClose()">
      <tun-close-v5 class="icon icon-large-scaled-svg-button"></tun-close-v5>
    </button>

  </div>

  <div class="animationWrapper" @fadeIn>
    @if ((songInfoOverlayView$ | async) == SONG_INFO_OVERLAY_VIEW.SONG_INFO_OVERLAY_VIEW_MAIN) {
      <tun-song-info-view
        [trackInfoOverlayData]="trackInfoOverlayData"
        (selectPlaylist)="onSelectPlaylist()"
      [@carousel]="{
        value: animationDirection,
        params: {
          duration: CAROUSEL_DURATION
        }
      }"
      class="fullContainer"
      >
    </tun-song-info-view>
  }

  @if ((songInfoOverlayView$ | async) == SONG_INFO_OVERLAY_VIEW.SONG_INFO_OVERLAY_VIEW_PLAYLISTS) {
    <tun-song-info-select-playlist-view
      [track]="trackInfoOverlayData.track"
      (back)="onBack()"
      [@carousel]="{
        value: animationDirection,
        params: {
          duration: CAROUSEL_DURATION
        }
      }"
    class="fullContainer"
    >
  </tun-song-info-select-playlist-view>
}


</div>

</div>
